import "../modules/segmentS2S";
import "../modules/analytics";

import { createApp } from "vue";
import giftBuilderData from "@/app/javascript/utils/giftBuilderData.json";
import GiftBuilder from "@/app/javascript/components/catalog/giftBuilder/GiftBuilder.vue";
import store from "../store/giftBuilder";
import router from "../routers/giftBuilder";
import I18n from "../plugins/i18n";

import { ready } from "../utils/listeners";

ready(() => {
  const node = document.getElementById("gift-builder-app");

  if (!node) {
    return;
  }

  const translations = JSON.parse(node.dataset.translations);

  const props = JSON.parse(node.dataset.props);

  const app = createApp(GiftBuilder);

  app.provide("giftBuilderData", giftBuilderData);

  app.use(router);
  app.use(store);
  app.use(I18n, translations);

  const initialBookType = props.categories[Object.keys(props.categories)[0]][0];
  store.commit("setBookType", initialBookType);

  const initialPageType = giftBuilderData["page-type"][0];
  store.commit("setPageType", initialPageType);

  store.commit("setRootPath", props.rootPath);
  store.commit("setCategories", props.categories);
  store.commit("setStoreCode", props.storeCode);

  app.mount(node);
});
